import { rankingsConstants } from "../_constants";
import { rankingsService } from "../_services";
import { alertActions } from "./";
//import { history } from '../_helpers';

export const rankingsActions = {
  getWeeklyDetail,
  getMonthlyDetail
};

function getWeeklyDetail(user, timestamp) {
  return dispatch => {
    dispatch(request());

    rankingsService.getWeeklyDetail(user, timestamp).then(
      detail => {
        dispatch(success(detail));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: rankingsConstants.DETAIL_REQUEST };
  }
  function success(detail) {
    return { type: rankingsConstants.DETAIL_SUCCESS, detail };
  }
  function failure(error) {
    return { type: rankingsConstants.DETAIL_FAILURE, error };
  }
}

function getMonthlyDetail(user, timestamp) {
  return dispatch => {
    dispatch(request());

    rankingsService.getMonthlyDetail(user, timestamp).then(
      detail => {
        dispatch(success(detail));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: rankingsConstants.DETAIL_REQUEST };
  }
  function success(detail) {
    return { type: rankingsConstants.MONTHLY_DETAIL_SUCCESS, detail };
  }
  function failure(error) {
    return { type: rankingsConstants.DETAIL_FAILURE, error };
  }
}
